import HowItWorks from 'components/pages/HowItWorks/HowItWorks';
import { buildPage } from 'utils/pageHelper';
export default buildPage(HowItWorks, {
  fullPage: true,
  metaData: {
    title: 'How it works',
    description:
      'With Qmee you can get rewarded for your opinions, your searches and your purchases. Share, shop & search to earn real cash.',
  },
});
